import { z } from 'zod';
import { MOTUS_MAX_LENGTH } from '../../games.js';

export const SetWordSchema = z
  .object({ matchId: z.string().min(1), word: z.string().min(1).max(40) })
  .strict();
export type SetWordInput = z.infer<typeof SetWordSchema>;

export const GuessSchema = z
  .object({ matchId: z.string().min(1), word: z.string().min(1).max(40) })
  .strict();
export type GuessInput = z.infer<typeof GuessSchema>;

export const TypingSchema = z
  .object({ matchId: z.string().min(1), draft: z.string().max(MOTUS_MAX_LENGTH) })
  .strict();
export type TypingInput = z.infer<typeof TypingSchema>;

export const AbandonSchema = z.object({ matchId: z.string().min(1) }).strict();
export type AbandonInput = z.infer<typeof AbandonSchema>;

export const RematchSchema = z.object({ matchId: z.string().min(1) }).strict();
export type RematchInput = z.infer<typeof RematchSchema>;
